import { EntityGridList } from "@/modules/common/components";
import { Pagination } from "@/modules/common/types/Pagination";
import { AdminManagementCompanyManagerUserResponse } from "@/service/response/admin-management-companies";

import ManagerUsersTabListHeader, { MIN_WIDTH_CLASS_NAME } from "./ManagerUsersTabListHeader";
import ManagerUsersTabListLine from "./ManagerUsersTabListLine";
import ManagerUsersTabListSkeleton from "./ManagerUsersTabListSkeleton";

interface ManagerUsersTabListProps {
  managementCompanyId: string;
  data?: Pagination<AdminManagementCompanyManagerUserResponse>;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const ManagerUsersTabList = ({ managementCompanyId, ...props }: ManagerUsersTabListProps) => (
  <EntityGridList
    {...props}
    minWidthClassName={MIN_WIDTH_CLASS_NAME}
    renderHeader={() => <ManagerUsersTabListHeader />}
    renderRow={(user) => <ManagerUsersTabListLine managementCompanyId={managementCompanyId} user={user} />}
    renderSkeleton={(limit) => <ManagerUsersTabListSkeleton limit={limit} />}
  />
);

export default ManagerUsersTabList;
